import React from "react";

const AGGridToolTip = (props) => {
  return (
    <div
      className={`ag-custom-tooltip ${props.className}`}
      style={{ backgroundColor: props.color }}
    >
      {props.type === "skuTooltip" ? (
        <div className="d-flex flex-column gap-1">
          {props.value.map((skuNumber) => (
            <p>{skuNumber}</p>
          ))}
        </div>
      ) : props.type === "actionTooltip" ? (
        props.ActionButtons(props)
      ) : (
        props.value
      )}
    </div>
  );
};

export default AGGridToolTip;
